import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles(theme => ({
  root: {
    height: 55,
    "&:hover": {
      backgroundColor: "transparent",
      "& p": {
        color: theme.palette.primary.brandPrimary,
        textTransform: "unset",
      },
    },
  },

  active: {
    backgroundColor: theme.palette.secondary.light,
  },

  listContainer: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },

  thumbnail: {
    width: 45,
    height: 45,
  },

  main: {
    marginLeft: theme.spacing(2),
    width: 200,
    padding: 0,
    flexGrow: 1,
  },

  title: {
    color: theme.palette.primary.brandPrimary,
    fontSize: "1.6rem",
    lineHeight: "1.7rem",
  },

  deleted: {
    color: theme.palette.error.main,
  },

  subtitle: {
    fontSize: ".9rem",
  },
}));

const AddMediaToParentMenuItem = props => {
  const {
    active,
    dataIndex,
    parent,
    checked,
    handleClick,
    onClick,
    forAutocomplete,
  } = props;
  const classes = useStyles();

  return forAutocomplete ? (
    <Fragment>
      <ListItemAvatar>
        <Avatar
          variant="rounded"
          alt={parent.name}
          src={`${parent.thumbnailUrl}&tc${Date.now()}`}
          className={classes.thumbnail}
        />
      </ListItemAvatar>
      <Tooltip title={parent.title || parent.name}>
        <ListItemText>
          <div className={classes.main}>
            <Typography
              classes={{
                root: clsx(classes.title, {
                  [classes.deleted]: parent.status === "DELETED",
                }),
              }}
              noWrap
            >
              {parent.title || parent.name}
            </Typography>
          </div>
        </ListItemText>
      </Tooltip>
      <ListItemSecondaryAction>
        <Checkbox
          color="primary"
          checked={checked}
          disabled={parent.status === "DELETED"}
          onChange={handleClick}
          inputProps={{ "aria-labelledby": parent.id }}
        />
      </ListItemSecondaryAction>
    </Fragment>
  ) : (
    <MenuItem
      data-index={dataIndex}
      classes={{
        root: clsx(classes.root, {
          [classes.active]: active,
        }),
      }}
      ListItemClasses={{ container: classes.listContainer }}
      button
      tabIndex={active ? 0 : -1}
      onClick={event => onClick(event, parent.id)}
    >
      <ListItemAvatar>
        <Avatar
          variant="rounded"
          alt={parent.name}
          src={`${parent.thumbnailUrl}&tc${Date.now()}`}
          className={classes.thumbnail}
        />
      </ListItemAvatar>
      <Tooltip title={parent.title || parent.name}>
        <ListItemText>
          <div className={classes.main}>
            <Typography classes={{ root: classes.title }} noWrap>
              {parent.title || parent.name}
            </Typography>
          </div>
        </ListItemText>
      </Tooltip>
      <ListItemSecondaryAction>
        <Checkbox
          color="primary"
          checked={checked}
          onChange={event => onClick(event, parent.id)}
          inputProps={{ "aria-labelledby": parent.id }}
        />
      </ListItemSecondaryAction>
    </MenuItem>
  );
};

export default AddMediaToParentMenuItem;
